import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _Promise from '/app/node_modules/babel-runtime/core-js/promise';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListItem from '~/components/collaborators/slide-item';
import newSellerModal from '~/components/collaborators/new-seller-modal';
import alertModal from '~/components/collaborators/alert-modal';
import editChannelModal from '~/components/collaborators/edit-channel';
import { mapState, mapActions } from 'vuex';
import loader from '~/components/modals/loader';

export default {
    fetch: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                app = _ref.app;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            store.commit('dashboard/details/setToolbarTitle', 'Colaboradores');
                            _context.prev = 1;
                            _context.next = 4;
                            return _Promise.all([store.dispatch('user/showListByRol')]);

                        case 4:
                            _context.next = 9;
                            break;

                        case 6:
                            _context.prev = 6;
                            _context.t0 = _context['catch'](1);

                            app.$controlMessage(_context.t0);

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 6]]);
        }));

        function fetch(_x) {
            return _ref2.apply(this, arguments);
        }

        return fetch;
    }(),
    asyncData: function asyncData(_ref3) {
        var app = _ref3.app,
            redirect = _ref3.redirect;

        if (app.$isBoss()) {
            return redirect('/channels');
        } else if (app.$isSupervisor()) {
            return redirect('/my-team');
        }
        return null;
    },

    components: {
        ListItem: ListItem,
        newSellerModal: newSellerModal,
        alertModal: alertModal,
        editChannelModal: editChannelModal,
        loader: loader
    },
    data: function data() {
        return {
            collaboratorsTitle: '',
            buttonNewCollaborator: '',
            typeOfTable: '',
            loaderText: 'Procesando información'
        };
    },

    computed: _extends({}, mapState({
        //isBoss
        listOfBoss: function listOfBoss(state) {
            return state.boss.items;
        }
    })),
    methods: {
        showChannels: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value) {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.updateShowChannels(value);

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function showChannels(_x2) {
                return _ref4.apply(this, arguments);
            }

            return showChannels;
        }(),
        updateShowChannels: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(value) {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$store.dispatch('boss/loadChannels', value);

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function updateShowChannels(_x3) {
                return _ref5.apply(this, arguments);
            }

            return updateShowChannels;
        }(),
        setDefaultToAdmin: function setDefaultToAdmin() {
            this.type = "Jefes";
            this.typeState = "Equipo Activo";
            this.collaboratorsTitle = "Jefes";
            this.buttonNewCollaborator = "Nuevo jefe";
            this.typeOfTable = "Channels";
            this.buttonAddColaborator = true;
            this.addBossButton = true;
            this.titlePrincipal = "Jefes";
        },
        openNewItem: function openNewItem() {
            this.$refs.newSellerModal.addNewBossModal();
        },
        completeForm: function completeForm() {
            this.$refs.alertModal.openModal();
            this.closeShowChannel();
        },
        upDateListBoss: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.$store.dispatch('user/showListByRol');

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function upDateListBoss() {
                return _ref6.apply(this, arguments);
            }

            return upDateListBoss;
        }(),
        addNewItem: function addNewItem(val) {
            this.$refs.editChannelModal.value = val.value;
            this.$refs.editChannelModal.createChannel();
        },
        editThisChannel: function editThisChannel(val) {
            this.$refs.newSellerModal.idUser = val;
            this.$refs.newSellerModal.editBossModal();
        },
        toDetailTable: function toDetailTable(val) {
            this.$refs.loaderModal.showLoader();
            this.$router.push({
                path: '/bosses/channel/' + val.val.item.id,
                query: { bossStatus: val.val.teamIsActive }
            });
        },
        closeShowChannel: function closeShowChannel() {
            var _this = this;

            if (this.listOfBoss) {
                this.listOfBoss.forEach(function (item, i) {
                    _this.$refs.listItem[i].showTable = false;
                });
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$nextTick(function () {
            _this2.multipleOptions = true;
            _this2.setDefaultToAdmin();
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/bosses/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/bosses/index.vue
// module chunks = 9